import React from 'react';
import { useCurrentSearchState } from 'controllers/SearchController/hooks/useCurrentSearchState';
import { useSearchController } from 'controllers/SearchController/SearchContext';
import useBuildQueryString from 'controllers/SearchController/hooks/useBuildQueryString';
import { ControllerQueryConfig } from 'controllers/SearchController/types';
import { TabNames } from 'types/enums';
import GenericSearchQuery from '../GenericSearchQuery/GenericSearchQuery';

const SearchQuery = ({
    samplesQueryConfig,
    packsQueryConfig,
}: {
    samplesQueryConfig?: ControllerQueryConfig;
    packsQueryConfig?: ControllerQueryConfig;
}) => {
    const { page, tab } = useCurrentSearchState();
    const {
        itemsPerPage,
        updateSamplesResult,
        updateSamplesLoading,
        updateSamplesError,
        updateSamplesCompleted,
        updateAllSamplesResult,
        updateAllSamplesLoading,
        updateAllSamplesError,
        updateAllSamplesCompleted,
        updatePacksResult,
        updatePacksLoading,
        updatePacksError,
        updatePacksCompleted,
        updateAllPacksResult,
        updateAllPacksLoading,
        updateAllPacksError,
        updateAllPacksCompleted,
    } = useSearchController();

    const queryString = useBuildQueryString();

    return (
        <>
            {samplesQueryConfig && (
                <GenericSearchQuery
                    queryConfig={samplesQueryConfig}
                    queryString={queryString}
                    page={tab !== TabNames.Samples ? 1 : page}
                    itemsPerPage={itemsPerPage}
                    updateResult={updateSamplesResult}
                    updateLoading={updateSamplesLoading}
                    updateError={updateSamplesError}
                    updateCompleted={updateSamplesCompleted}
                    updateAllResult={updateAllSamplesResult}
                    updateAllLoading={updateAllSamplesLoading}
                    updateAllError={updateAllSamplesError}
                    updateAllCompleted={updateAllSamplesCompleted}
                />
            )}
            {packsQueryConfig && (
                <GenericSearchQuery
                    queryConfig={packsQueryConfig}
                    queryString={queryString}
                    page={tab !== TabNames.Packs ? 1 : page}
                    itemsPerPage={itemsPerPage}
                    updateResult={updatePacksResult}
                    updateLoading={updatePacksLoading}
                    updateError={updatePacksError}
                    updateCompleted={updatePacksCompleted}
                    updateAllResult={updateAllPacksResult}
                    updateAllLoading={updateAllPacksLoading}
                    updateAllError={updateAllPacksError}
                    updateAllCompleted={updateAllPacksCompleted}
                />
            )}
        </>
    );
};

export default SearchQuery;
